import { createSelector } from "reselect";

import getPartsState from "./getPartsState";

const getPartsWithPrice = createSelector(getPartsState, ({ parts }) => {
  const partsWithPrice = parts?.filter(({ price }) => price !== 0);

  return partsWithPrice;
});

export type GetPartsWithPriceType = ReturnType<typeof getPartsWithPrice>;
export default getPartsWithPrice;
